import React from 'react'
import moment from 'moment'
import EdicionCamionesCalados from '../containers/EdicionCamionesCalados'
import ReportProblemIcon from '@material-ui/icons/ReportProblem'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import TableValueAction from '../../../../../MuiTable/components/TableValueAction'
import InfoCpa from '../../../busquedaCpa/InfoCpa'
import InfoIcon from '@material-ui/icons/Info'

export const COLUMNS_CAMIONES_CALADO = [
  {
    name: 'caravana',
    label: ' ',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (c) => !c && (
        <Tooltip title='Descarga silo aparte'>
          <InfoIcon color='action' style={{ fontSize: '1.2rem', cursor: 'help' }} />
        </Tooltip>
      )
    }
  },
  {
    name: 'estadoCtg',
    label: ' ',
    options: {
      filter: false,
      viewColumns: false,
      customBodyRender: (estadoCtg) => (estadoCtg === 'A')
        ? <Tooltip title={'Camión rechazado esperando ser actualizado desde ARCA'}>
          <IconButton>
            <ReportProblemIcon fontSize='medium' color='primary' />
          </IconButton>
        </Tooltip>
        : null
    }
  },
  {
    name: 'cartaDePorteAutomotor',
    label: 'Carta de porte',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (numero) => {
        return (
          <>
            {numero
              ? <TableValueAction
                value={numero}
                title=' '
                content={<InfoCpa cpa={numero} />} />
              : null
            }
          </>
        )
      }
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      filterList: []
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true,
      filterList: [],
      filterType: 'checkbox',
      customBodyRender: (v) => {
        return ((v.trim() === 'UNDEF') ? ' - ' : v)
      }
    }
  },
  {
    name: 'fechaDeCalado',
    label: 'Fecha Calado',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (fecha) => fecha ? <>{moment(fecha).format('DD-MM HH:mm')}</> : null
    }
  },
  {
    name: 'exportador',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'titular',
    label: 'Titular de cupo',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'camion',
    label: 'Camión',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'estadoCalificacion',
    label: 'Estado',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'calificacionCereal',
    label: 'Calificación',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'humedad',
    label: 'Humedad',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'puestoDeCalado',
    label: 'Puesto',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      customBodyRender: p => {
        const puesto = (p === 'calle_1-2' ? '1/2' : '3/4')
        return <>{puesto}</>
      }
    }
  },
  {
    name: 'calleDeCalado',
    label: 'Calle',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'estadoAutorizacion',
    label: 'Estado autorización',
    options: {
      filter: true,
      sort: true,
      filterList: [],
      filterType: 'checkbox'
    }
  },
  {
    name: 'autodescargable',
    label: 'Autodescargable',
    options: {
      filter: true,
      sort: true,
      display: false,
      filterList: [],
      customBodyRender: autodescargable => {
        return (autodescargable) ? 'Si' : '  '
      }
    }
  },
  {
    name: 'cartaDePorteAutomotor',
    label: 'Operaciones',
    options: {
      filter: false,
      sort: false,
      viewColumns: false,
      customBodyRender: (value, tableMeta) => {
        return <EdicionCamionesCalados numero={value} data={tableMeta} />
      }
    }
  }
]

export const COLUMNS_CAMIONES_CALADO_TO_PRINT = [
  {
    name: 'cartadeporte',
    label: 'Carta de porte',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'fechaDeCalado',
    label: 'Fecha de Calado',
    width: 80,
    mantenerCase: true
  },
  {
    name: 'exportador',
    label: 'Exportador',
    width: 100,
    mantenerCase: true
  },
  {
    name: 'titular',
    label: 'Titular',
    width: 80,
    mantenerCase: true
  },
  {
    name: 'camion',
    label: 'Camión',
    width: 40,
    mantenerCase: true
  },
  {
    name: 'estadoCalificacion',
    label: 'Estado',
    width: 40,
    mantenerCase: true
  },
  {
    name: 'calificacionCereal',
    label: 'Calificación',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'humedad',
    label: 'Humedad',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'puestoDeCalado',
    label: 'Puesto',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'calleDeCalado',
    label: 'Calle',
    width: 70,
    mantenerCase: true
  }
]
